import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { registerViaLink } from "../../services/publicSessionLinkService";
import { useAuth } from "../../context/AuthContext";
import "./sessionLanding.css";

const INITIAL = { name: "", email: "", mobile: "", countryCode: "+91" };

const RegistrationForm = ({ token, onOtpRequired }) => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState(INITIAL);
  const [countryCodes, setCountryCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/public/country-codes`)
      .then((res) => setCountryCodes(res.data?.data || []))
      .catch(() => {});
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      name: form.name.trim(),
      email: form.email.trim(),
      mobile: form.mobile.trim(),
      countryCode: form.countryCode,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      consentGiven: true,
      whatsappEnabled: false,
    };

    setLoading(true);
    const result = await registerViaLink(token, payload);
    setLoading(false);

    const data = result.data;
    if (data?.status === "SUCCESS") {
      login(data, data.jwtToken);
      navigate("/", { replace: true });
    } else if (data?.status === "OTP_REQUIRED") {
      onOtpRequired({ email: payload.email, userName: data.userName, message: data.message });
    } else {
      setError(data?.message || result.message || "Registration failed. Please try again.");
    }
  };

  return (
    <div className="sl-form-section">
      <h3>Register for this Session</h3>
      <form onSubmit={handleSubmit}>
        <div className="sl-field">
          <label>Full Name *</label>
          <input name="name" type="text" value={form.name} onChange={handleChange} placeholder="John Doe" required />
        </div>
        <div className="sl-field">
          <label>Email Address *</label>
          <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="john@example.com" required />
        </div>
        <div className="sl-field">
          <label>Mobile Number *</label>
          <div className="sl-mobile-row">
            <select name="countryCode" value={form.countryCode} onChange={handleChange}>
              {countryCodes.length > 0
                ? countryCodes.map((c) => <option key={c.id} value={c.dialCode}>{c.isoCode} {c.dialCode}</option>)
                : <option value="+91">IN +91</option>}
            </select>
            <input
              name="mobile" type="tel" value={form.mobile}
              onChange={(e) => setForm((f) => ({ ...f, mobile: e.target.value.replace(/\D/g, "") }))}
              placeholder="9876543210" required maxLength={15}
            />
          </div>
        </div>
        {error && <p className="sl-form-error">{error}</p>}
        <button type="submit" className="sl-submit-btn" disabled={loading}>
          {loading ? "Registering..." : "Register for Free 🚀"}
        </button>
        <div className="sl-whats-next">
          <p className="sl-whats-next-title">✅ What happens next?</p>
          <ol className="sl-whats-next-list">
            <li>You'll receive a <strong>confirmation email</strong> with your session details.</li>
            <li>A <strong>Zoom link</strong> will be shared before the session starts.</li>
            <li>Install the <strong>Zoom application</strong> on your device.</li>
            <li>Join on time and get ready to <strong>speak confidently!</strong> 🎤</li>
          </ol>
        </div>
      </form>
    </div>
  );
};

export default RegistrationForm;
